/**
 * Header content type constants
 * @typedef {Object} CONTENTTYPE 
 * @property {string} FORMDATA Form data.
 * @property {string} JSON Json data.
 * @property {string} XML Xml data.
 * @property {string} TEXT Html/text data.
 * @property {string} ZIP Zip file.
 * @property {string} XEXCEL Excel xml.
 */

/**
 * Fetch API mode.
 * @typedef {Object} FETCHMODES
 * @property {string} SAMEORIGIN Ajax requests for the same origin.
 * @property {string} CORS Ajax requests for cross site reference.
 */

/**
 * Replace mode after submit result.
 * @typedef {Object} REPLACEMODE
 * @property {string} NOREPLACE No replace the current container.
 * @property {string} REPLACE Replace the container with new content.
 * @property {string} INSERTAFTER Insert content after the current container.
 * @property {string} INSERTBEFORE Insert content before the current container.
 */

/**
 * @typedef {Object} ATTEMPTS Number of attempts for several situations.
 * @property {Number} AJAX Limit number of attempt for ajax communications.
 */

/**
 * @typedef {Array} CONTAINER_COLLECTION valid container collection.
  * @property {String} DIV Html container: <div>
  * @property {String} FORM Html container: <form>
  * @property {String} SECTION Html container: <section>
  * @property {String} TABLE Html container: <table>
  * @property {String} FIELDSET Html container: <fieldset>
  * @property {String} ASIDE Html container: <aside>
  * @property {String} FOOTER Html container: <footer>
  * @property {String} HEADER Html container: <header>
  * @property {String} NAV Html container: <nav>
  * @property {String} ARTICLE Html container: <article>
 */

/**
 * Fetch api response methods
 * @typedef {Object} FETCH_REPONSES 
 * @property {String} TEXT <response object>.text() method
 * @property {String} JSON <response object>.json()  method
 * @property {String} FORMDATA <response object>.text() method
 * @property {String} BLOB <response object>.blob() method
 * @property {String} ARRAY_BUFFER <response object>.arrayBuffer() method
 */
/**
 * Captcha options.
 * @typedef {Object} CAPTCHA_OPTIONS 
 * @property {THEME_OPTIONS} THEME Captcha theme color.
 * @property {SIZE_OPTIONS} SIZE Captcha size.
 * @property {BADGE_OPTIONS} BADGE Captcha position (only invisible captcha).
 */
/**
 * Captcha theme color.
 * @typedef {Object} THEME_OPTIONS 
 * @property {String} DARK Dark Theme.
 * @property {String} LIGHT Light Theme.
 */
/**
 * Captcha SIZE.
 * @typedef {Object} SIZE_OPTIONS 
 * @property {String} COMPACT compact size.
 * @property {String} NORMAL normal size.
 * @property {String} INVISIBLE invisible captcha.
 */
/**
 * Captcha position (only invisible captcha).
 * @typedef {Object} BADGE_OPTIONS 
 * @property {String} BOTTOMRIGHT bottom right position.
 * @property {String} BOTTOMLEFT bottom left position.
 * @property {String} INLINE 'inline' lets position it with CSS.
 */
/**
 * Constant values
 * @typedef {Object} CONSTANTS
 * @property {CONTENTTYPE} CONTENTTYPE Header content type constants
 * @property {FETCHMODES} FETCHMODES Fetch API mode.
 * @property {REPLACEMODE} REPLACEMODE Replace mode after submit result.
 * @property {ATTEMPTS} ATTEMPTS Number of attempts for several situations.
 * @property {CONTAINER_COLLECTION} CONTAINER_COLLECTION valid container collection.
 * @property {FETCH_REPONSES} FETCH_REPONSES Fetch api response methods.
 * @property {CAPTCHA_OPTIONS} CAPTCHA Captcha options.
 */

/**
 * Several constant values for general purpose.
 * @type {CONSTANTS}
 */
const JFM_CONST = {
    CONTENTTYPE: {
        FORMDATA: 'multipart/form-data',
        JSON: 'application/json',
        XML: 'text/xml',
        TEXT: 'text/html',
        ZIP: 'application/zip',
        XEXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    FETCHMODES: {
        SAMEORIGIN: 'same-origin',
        CORS: 'cors'
    },
    REPLACEMODE: {
        NOREPLACE: 'NOREPLACE',
        REPLACE: 'REPLACE',
        INSERTAFTER: 'AFTER',
        INSERTBEFORE: 'BEFORE'
    },
    ATTEMPTS: {
        AJAX: 3
    },
    CONTAINER_COLLECTION: [
        'DIV',
        'FORM',
        'SECTION',
        'TABLE',
        'FIELDSET',
        'ASIDE',
        'FOOTER',
        'HEADER',
        'NAV',
        'ARTICLE'
    ], 
    FETCH_REPONSES :{
        TEXT : 'TEXT',
        JSON : 'JSON',
        FORMDATA : 'FORMDATA',
        BLOB: 'BLOB',
        ARRAY_BUFFER : 'ARRAY_BUFFER'
    },
    CAPTCHA:
    {
        THEME: {
            DARK: 'dark',
            LIGHT : 'light',
        },
        SIZE: {
            COMPACT: 'compact',
            NORMAL: 'normal',
            INVISIBLE : 'invisible'
        },
        BADGE: {
            BOTTOMRIGHT: 'bottomright',
            BOTTOMLEFT: 'bottomleft',
            INLINE : 'inline'
        }
    }
};